import React from 'react';
import { NOTIFICATION_TYPE } from './notification';

const EXCEL_ERR_TRY_AGAIN = {
  id: 'EXCEL_ERR_TRY_AGAIN',
  type: NOTIFICATION_TYPE.ERROR,
  title: 'Sorry, your Excel file has been failed to upload ',
  content: (
    <h5>
      Oh no, looks like we can’t process your Excel file. Please try again
      later.
    </h5>
  ),
};

const EXCEL_ERR_GET_QUOTE_FAILED = {
  id: 'EXCEL_ERR_GET_QUOTE_FAILED',
  type: NOTIFICATION_TYPE.ERROR,
  title: 'Sorry, your Excel file has been failed to upload ',
  content: (
    <h5>
      Looks like your Excel file contains some errors. Please verify the sender
      and recipient addresses in your Excel file.
    </h5>
  ),
};

const EXCEL_ERR_BROWSER_LANGUAGE = {
  id: 'EXCEL_ERR_BROWSER_LANGUAGE',
  type: NOTIFICATION_TYPE.ERROR,
  title: 'Sorry, your Excel file has been failed to upload ',
  content: (
    <h5>
      Oh no, looks like we can’t process your Excel file. Please make sure the
      browser language is the same with Excel file
    </h5>
  ),
};

const EXCEL_ERR_NOT_LATEST = {
  id: 'EXCEL_ERR_NOT_LATEST',
  type: NOTIFICATION_TYPE.ERROR,
  title: 'Sorry, your Excel file has been failed to upload',
  content: (
    <h5>
      Please make sure you have downloaded the latest Excel file before
      uploading
    </h5>
  ),
};

const REVIEW_ERR_TRY_AGAIN = {
  id: 'REVIEW_ERR_TRY_AGAIN',
  type: NOTIFICATION_TYPE.ERROR,
  title: 'Sorry, create delivery failed',
  content: (
    <h5>
      Oh no, looks like we can’t process your creating deliveries, please try
      again
    </h5>
  ),
};

const BULK_BOOKING_ERR = {
  id: 'BULK_BOOKING_ERROR',
  type: NOTIFICATION_TYPE.ERROR,
  title: 'Creating some orders have been failed!',
  duration: 10,
};

const BULK_BOOKING_ERR_TRY_AGAIN = {
  id: 'BULK_BOOKING_ERROR',
  type: NOTIFICATION_TYPE.ERROR,
  title:
    'Sorry, there was an unexpected error, please try again, or contact your account manager for help!',
  duration: 10,
};

const NOTIFICATION_CONFIGS = {
  err_try_again: EXCEL_ERR_TRY_AGAIN,
  err_browser_language: EXCEL_ERR_BROWSER_LANGUAGE,
  err_not_latest: EXCEL_ERR_NOT_LATEST,
  err_get_quote_failed: EXCEL_ERR_GET_QUOTE_FAILED,
  review_err_try_again: REVIEW_ERR_TRY_AGAIN,
  err_bulk_booking: BULK_BOOKING_ERR,
  err_bulk_booking_try_again: BULK_BOOKING_ERR_TRY_AGAIN,
};

export const customizedTextNotificationConfig = (title, content) => ({
  id: content,
  type: NOTIFICATION_TYPE.ERROR,
  title,
  content: <h5>{content}</h5>,
  duration: 10,
});

export default NOTIFICATION_CONFIGS;
